import { render, staticRenderFns } from "./MyOrderInfo.vue?vue&type=template&id=31c01e9f&scoped=true&"
import script from "./MyOrderInfo.vue?vue&type=script&lang=js&"
export * from "./MyOrderInfo.vue?vue&type=script&lang=js&"
import style0 from "./MyOrderInfo.vue?vue&type=style&index=0&id=31c01e9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c01e9f",
  null
  
)

export default component.exports